<template>
  <div class="recharge-page">
    <!-- 澶撮儴杩斿洖鏍?-->
    <div class="nav-bar">
      <div class="back-btn" @click="goBack"></div>
      <span class="nav-title">{{ $t('recharge.title') }}</span>
      <div class="placeholder"></div>
    </div>
    <!-- 鍏呭€奸噾棰濋€夋嫨 -->
    <div class="section first-section">
      <div class="section-title">{{ $t('recharge.selectAmount') }}</div>
      <div class="amount-grid">
        <div
          v-for="item in presetAmounts"
          :key="item.id"
          class="amount-item"
          :class="{ active: selectedItem && selectedItem.id === item.id }"
          @click="selectAmount(item)"
        >
          <div class="amount-content">
            <span class="amount-number">{{ item.title }}</span>
            <img 
              class="amount-icon" 
              src="@/static/video/koin.png" 
              alt="coin icon"
            />
            <span class="amount-price">{{ getCurrencyText(item.currency_symbol) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 鍏呭€艰鏄?-->
    <div class="section">
      <div class="section-title">{{ $t('recharge.noticeTitle') }}</div>
      <div class="info-card">
        <div class="info-line">{{ $t('recharge.notice1') }}</div>
        <div class="info-line">{{ $t('recharge.notice2') }}</div>
        <div class="info-line">{{ $t('recharge.notice3') }}</div>
        <div class="info-line">{{ $t('recharge.notice4') }}</div>
        <div class="info-line">{{ $t('recharge.notice5') }}</div>
      </div>
    </div>

    <!-- 鍏呭€兼寜閽?-->
    <div class="recharge-action">
      <button
        class="recharge-btn"
        :class="{ disabled: !canRecharge }"
        :disabled="!canRecharge"
        @click="handleRecharge"
      >
        {{ $t('recharge.btn') }} {{ selectedPriceText }}
      </button>
    </div>

    <div class="footnote">
      <span>{{ $t('recharge.footnote') }}</span>
    </div>
    <div style="width:100%; height:60px;"></div>
  </div>
</template>

<script>
import {rechargeTemp, buy as buyRecharge} from "@/apis/recharge"
import {Toast} from "vant"
import { isActiveMember } from "@/utils/member"

export default {
  name: "RechargePage",
  data() {
    return {
      presetAmounts: [],
      selectedItem: null,
      selectedAmount: 0,
    };
  },
  computed: {
    activeMember() {
      const userInfo = this.$getUserInfo ? this.$getUserInfo() : null;
      return isActiveMember(userInfo);
    },
    canRecharge() {
      return this.selectedAmount > 0 && !this.activeMember;
    },
    selectedPriceText() {
      if (!this.selectedItem) return "";
      return this.getCurrencyText(this.selectedItem.currency_symbol) || this.formatPoints(this.selectedAmount);
    },
  },
  mounted() {
    this.chargeList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    chargeList() {
         rechargeTemp().then((res) => {
          if (res.code === 1) {
            this.presetAmounts = res.data.list || [];
            if (this.presetAmounts.length > 0) {
              this.selectAmount(this.presetAmounts.find(item => Number(item.default) === 1) || this.presetAmounts[0]);
            }
          }
        })
        .catch((err) => {
          console.error("get recharge select", err);
        });
    },
    formatPoints(points) {
      return Number(points || 0).toLocaleString("ja-JP");
    },
    getCurrencyText(value) {
      if (!value) return "";
      if (typeof value !== "string") return value;
      try {
        const parsed = JSON.parse(value);
        return parsed["117"] || Object.values(parsed)[0] || "";
      } catch (e) {
        return value;
      }
    },
    selectAmount(item) {
      this.selectedItem = item;
      this.selectedAmount = Number(item.amount || 0);
    },
    async handleRecharge() {
        if (!this.canRecharge) return;

        try {
            const params = {
                package_id: this.selectedItem.id,
                back_url: window.location.href,
            };

            const res = await buyRecharge(params);
            if (!res || res.code !== 1) {
                Toast(res?.msg || this.$t('recharge.createOrderFail'))
                return;
            }

            const orderData = res.data || {};
            this.$router.push("/checkout/checkout?order_no=" + orderData.out_trade_no);
            // const payUrl = orderData.pay_url || '';

            // if (!payUrl) {
            //     console.log("pay_url is empty", orderData);
            //     Toast(this.$t('recharge.rechargeError'));
            //     return;
            // }

            // window.location.href = payUrl;
        } catch (e) {
            console.error('Recharge exception:', e);
            Toast(this.$t('recharge.rechargeError'));
        }
    },
  },
};
</script>

<style scoped>
.recharge-page {
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  background: #f5f5f7;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: none;
}

/* 瀵艰埅鏍?*/
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 49px;
  padding: 0 16px;
  background: rgba(245, 245, 247, 0.9);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 20;
  box-sizing: border-box;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
}

.back-btn {
  width: 40px;
  height: 40px;
  position: relative;
  font-size: 0;
  color: #007aff;
  cursor: pointer;
}

.back-btn::before {
  content: "";
  position: absolute;
  top: 14px;
  left: 15px;
  width: 11px;
  height: 11px;
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg);
}

.back-btn:active {
  opacity: 0.6;
}

.nav-title {
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
}

.placeholder {
  width: 32px;
}

/* 閫氱敤鍖哄潡 */
.section {
  margin: 0 16px 22px;
}
.first-section {
  margin-top: 16px;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 12px;
  border-left: 0;
  padding-left: 0;
}

/* 閲戦缃戞牸 */
.amount-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.amount-item {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.12s ease, border-color 0.12s ease, background 0.12s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.amount-item.active {
  border-color: #007aff;
  background: #e8f2ff;
  box-shadow: none;
}

/* 淇敼鐐癸細鏂板閲戦鍐呭瀹瑰櫒鏍峰紡锛堟暟瀛?鍥炬爣锛?*/
.amount-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

.amount-number {
  font-size: 18px;
  font-weight: 700;
  color: #1d1d1f;
  line-height: 1;
}

.amount-price {
  flex: 0 0 100%;
  font-size: 13px;
  font-weight: 500;
  color: #8e8e93;
  line-height: 1;
  text-align: center;
}

/* 淇敼鐐癸細鍥炬爣鏍峰紡 */
.amount-icon {
  width: 24px;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
}

/* 鍏呭€艰鏄庡崱鐗?*/
.info-card {
  background: #fff;
  border-radius: 16px;
  padding: 18px 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.info-line {
  font-size: 13px;
  line-height: 1.65;
  color: #3a3a3c;
  margin-bottom: 8px;
  word-break: break-word;
}

.info-line:last-child {
  margin-bottom: 0;
}

/* 鍏呭€兼寜閽?*/
.recharge-action {
  padding: 8px 16px 20px;
}

.recharge-btn {
  background: #007aff;
  border: none;
  color: #fff;
  font-weight: 600;
  font-size: 17px;
  height: 52px;
  line-height: 52px;
  border-radius: 999px;
  box-shadow: none;
  width: 100%;
  cursor: pointer;
}

.recharge-btn:active {
  background: #0067d8;
  transform: scale(0.98);
}

.recharge-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* 鑴氭敞 */
.footnote {
  padding: 0 16px 24px;
  font-size: 12px;
  color: #8e8e93;
  text-align: center;
}
</style>
